import React from 'react';
import { Link } from 'react-router-dom';

const IntegrationsCrystalPOS = () => {
  return (
    <>
      <section className="cb-integrations-details__section">
        <h3 className="cb-integrations-details__title">Overview</h3>

        <p>
          Connect your Crystal POS system with Clientbook. This connection will seamlessly merge your business&apos;s
          Crystal POS data into Clientbook&apos;s desktop and mobile platforms. This includes your list of clients,
          products and sales transactions. Click on Install to get started!
          <br />
          <br />
          Please be sure the Crystal POS user has the rights to access all relevant information. If the user is removed
          from the connected Crystal POS account, the account will be disabled.
        </p>
      </section>

      <section className="cb-integrations-details__section">
        <h3 className="cb-integrations-details__title">Key Features</h3>

        <p>By adding your Crystal POS information to Clientbook, you can:</p>

        <ul className="cb-integrations-details__list">
          <li>
            Sync your list of clients to send automated messages, request payments and track specific life events to
            maximize POS activity.
          </li>

          <li>
            Attach your associates to document sales opportunities and intensify your sales team&apos;s efficiency.
          </li>

          <li>
            Connect your products to record sales triggers and transaction history to effectively document your sales in
            a clear, easy-to-use platform.
          </li>

          <li>
            Maximize communication with your clients by syncing documented Crystal POS sales transactions to trigger
            automated messages, life events and client activities.
          </li>
        </ul>
      </section>

      <section className="cb-integrations-details__section">
        <h3 className="cb-integrations-details__title">Helpful Links</h3>

        <ul className="cb-integrations-details__list">
          <li>
            <Link to="/Help/contact-support">Clientbook Help Center</Link>
          </li>
        </ul>
      </section>
    </>
  );
};

export default IntegrationsCrystalPOS;
